import { render } from "./TagAutoInputComponent.vue?vue&type=template&id=07571708"
import script from "./TagAutoInputComponent.vue?vue&type=script&lang=js"
export * from "./TagAutoInputComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__